import axios from 'axios';
import store from '../store/index'
import router from "../router";
export default () => {
    let axiosObject = axios.create({
        baseURL: `${process.env.VUE_APP_BASE_URL}/api`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${store.getters.token}`,
            'X-CLIENT-VERSION':`web-${process.env.VUE_APP_VERSION}`,
        },

    });

    axiosObject.interceptors.request.use((request) => {
        if(request.params){
            request.params['language'] = store.getters.language
        }
        else{
            request.params = {
                'language':store.getters.language
            }
        }


        return request
    })
    axiosObject.interceptors.response.use((response) => {
            if(response.headers['content-type'] === "application/pdf"){
                return response
            }

            if(store.getters.maintenanceMode){
                store.dispatch('setMaintanceMode',false)
            }
            if(store.getters.limitError){
                store.dispatch('setLimitError',false)
            }
            if(response.data.meta){
                return response.data
            }
            return response.data.data || response.data
        },
        function (error) {
            if(error.response.status === 503 && error.response.data.status === 'maintenance_mode'){
                store.dispatch('setMaintanceMode',true)
                router.push({ name: 'maintenance'})
            }
            if(error.response.status === 429 && error.response.data.code === 'too-many-attempts-exception'){
              store.dispatch('setLimitError',true)
            }
            if(error.response.data.code === 'user-not-login-exception'){
                store.dispatch('logout')

            }
            return Promise.reject(error)

        })

    return axiosObject;
};
